export const messages = {
  en: {
    resourceDetail: {
      page: {
        title: 'Item Detail',
        subtitle: 'View item archives with purchase and usage records',
        empty: 'No record found'
      },
      itemInfo: 'Item Information',
      itemNameWithCode: 'Item Name(Code):',
      warehouseName: 'Warehouse Name:',
      itemType: 'Item Type:',
      itemSpec: 'Item Specification:',
      fixedItem: 'Fixed Item:',
      referencePrice: 'Reference Price:',
      chargeStandard: 'Charge Standard:',
      itemStock: 'Item Stock:',
      minMeasurement: 'Minimum Measurement:',
      minMeasurementTotal: 'Minimum Measurement Total:',
      itemAvgPrice: 'Item Average Price:',
      purchaseRecord: 'Purchase Record',
      useRecordText: 'Use Record',
      inventoryRecord: 'Inventory Record',
      allocationRecord: 'Allocation Record',
      transferRecord: 'Transfer Record',
      usageRecord: 'Usage Record',
      purchase: {
        applyOrderId: 'Application No.',
        applicant: 'Applicant',
        endUser: 'End User',
        itemType: 'Item Type',
        itemName: 'Item Name',
        itemSpec: 'Item Specification',
        fixedItem: 'Fixed Item',
        supplier: 'Supplier',
        warehouse: 'Warehouse',
        applyQuantity: 'Application Quantity',
        actualQuantity: 'Actual Quantity',
        purchasePrice: 'Purchase Price',
        totalPrice: 'Total Price',
        remark: 'Remark',
        status: 'Status',
        createTime: 'Create Time'
      },
      itemOut: {
        applyOrderId: 'Application No.',
        applicant: 'Applicant',
        endUser: 'End User',
        itemType: 'Item Type',
        itemName: 'Item Name',
        itemSpec: 'Item Specification',
        fixedItem: 'Fixed Item',
        supplier: 'Supplier',
        warehouse: 'Warehouse',
        applyQuantity: 'Application Quantity',
        quantity: 'Quantity',
        purchasePrice: 'Purchase Price',
        totalPrice: 'Total Price',
        remark: 'Remark',
        status: 'Status',
        createTime: 'Create Time'
      },
      inventory: {
        inventoryId: 'Inventory No.',
        inventoryName: 'Inventory Name',
        inventoryTime: 'Inventory Time',
        warehouse: 'Warehouse',
        inventoryPerson: 'Inventory Person',
        status: 'Status',
        createTime: 'Create Time'
      },
      allocation: {
        allocationId: 'Allocation No.',
        itemType: 'Item Type',
        itemName: 'Item Name',
        itemSpec: 'Item Specification',
        fixedItem: 'Fixed Item',
        originalStock: 'Original Stock',
        allocationQuantity: 'Allocation Quantity',
        sourceWarehouse: 'Source Warehouse',
        targetWarehouse: 'Target Warehouse',
        applicant: 'Applicant',
        remark: 'Remark',
        allocationType: 'Allocation Type',
        status: 'Status',
        createTime: 'Create Time'
      },
      allocationUser: {
        id: 'ID',
        itemType: 'Item Type',
        itemName: 'Item Name',
        itemSpec: 'Item Specification',
        fixedItem: 'Fixed Item',
        transferUser: 'Transfer User',
        transferTarget: 'Transfer Target',
        originalStock: 'Original Stock',
        transferQuantity: 'Transfer Quantity',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      useRecord: {
        id: 'ID',
        repairId: 'Repair ID',
        itemId: 'Item ID',
        itemType: 'Item Type',
        itemName: 'Item Name',
        itemSpec: 'Item Specification',
        fixedItem: 'Fixed Item',
        useType: 'Use Type',
        useQuantity: 'Use Quantity',
        itemPrice: 'Item Price',
        userId: 'User ID',
        userName: 'User Name',
        createTime: 'Create Time',
        remark: 'Remark'
      }
    }
  },
  zh: {
    resourceDetail: {
      page: {
        title: '物品详情',
        subtitle: '查看物品档案与采购领用盘点调拨记录',
        empty: '暂无记录'
      },
      itemInfo: '物品信息',
      itemNameWithCode: '物品名称(编号):',
      warehouseName: '仓库名称:',
      itemType: '物品类型:',
      itemSpec: '物品规格:',
      fixedItem: '固定物品:',
      referencePrice: '参考价格:',
      chargeStandard: '收费标准:',
      itemStock: '物品库存:',
      minMeasurement: '最小计量:',
      minMeasurementTotal: '最小计量总数:',
      itemAvgPrice: '物品均价:',
      purchaseRecord: '采购记录',
      useRecordText: '领用记录',
      inventoryRecord: '盘点记录',
      allocationRecord: '调拨记录',
      transferRecord: '转赠记录',
      usageRecord: '使用记录',
      purchase: {
        applyOrderId: '申请单号',
        applicant: '申请人',
        endUser: '使用人',
        itemType: '物品类型',
        itemName: '物品名称',
        itemSpec: '物品规格',
        fixedItem: '固定物品',
        supplier: '供应商',
        warehouse: '物品仓库',
        applyQuantity: '申请数量',
        actualQuantity: '实际采购数量',
        purchasePrice: '采购价格',
        totalPrice: '总价',
        remark: '申请备注',
        status: '状态',
        createTime: '创建时间'
      },
      itemOut: {
        applyOrderId: '申请单号',
        applicant: '申请人',
        endUser: '使用人',
        itemType: '物品类型',
        itemName: '物品名称',
        itemSpec: '物品规格',
        fixedItem: '固定物品',
        supplier: '供应商',
        warehouse: '物品仓库',
        applyQuantity: '申请数量',
        quantity: '数量',
        purchasePrice: '采购价格',
        totalPrice: '总价',
        remark: '申请备注',
        status: '状态',
        createTime: '创建时间'
      },
      inventory: {
        inventoryId: '盘点单号',
        inventoryName: '盘点名称',
        inventoryTime: '盘点时间',
        warehouse: '盘点仓库',
        inventoryPerson: '盘点人',
        status: '状态',
        createTime: '创建时间'
      },
      allocation: {
        allocationId: '调拨单号',
        itemType: '物品类型',
        itemName: '物品名称',
        itemSpec: '物品规格',
        fixedItem: '固定物品',
        originalStock: '被调仓库原库存',
        allocationQuantity: '调拨数量',
        sourceWarehouse: '被调仓库',
        targetWarehouse: '目标仓库',
        applicant: '申请人',
        remark: '调拨备注',
        allocationType: '调拨类型',
        status: '状态',
        createTime: '时间'
      },
      allocationUser: {
        id: '编号',
        itemType: '物品类型',
        itemName: '物品名称',
        itemSpec: '物品规格',
        fixedItem: '固定物品',
        transferUser: '转赠人',
        transferTarget: '转赠对象',
        originalStock: '原有库存',
        transferQuantity: '转赠数量',
        createTime: '创建时间',
        remark: '备注'
      },
      useRecord: {
        id: '编号',
        repairId: '维修编号',
        itemId: '物品编号',
        itemType: '物品类型',
        itemName: '物品名称',
        itemSpec: '物品规格',
        fixedItem: '固定物品',
        useType: '使用类型',
        useQuantity: '使用数量',
        itemPrice: '物品价格',
        userId: '使用人ID',
        userName: '使用人',
        createTime: '创建时间',
        remark: '备注'
      }
    }
  }
}